import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthModule } from '../auth/auth.module';
import { ValidationResultsModule } from '../shared/components/validation-results/validation-results.module';
import { MaterialModule } from '../shared/material.module';
import { MVMSpinnerBtnModule } from '../shared/mvm-components/mvm-spinner-btn/mvm-spinner-btn.module';
import { NoteEntryComponent } from './entry.component';
import { NoteConfirmationComponent } from './note-confirmation.component';
import { NoteManageService } from './note-manage.service';
import { NoteModalComponent } from './note-modal/note-modal.component';
import { NoteComponent } from './note.component';
import { NoteSingleViewComponent } from './single-view.component';
import { NoteModelHistoryComponent } from './note-modal/note-history/note-mode-history.component';
import { TableModule } from 'primeng/table';

@NgModule({
    declarations: [
        NoteSingleViewComponent,
        NoteEntryComponent,
        NoteComponent,
        NoteConfirmationComponent,
        NoteModalComponent,
        NoteModelHistoryComponent
    ],
    providers: [
        NoteManageService
    ],
    imports: [
        AuthModule,
        CommonModule,
        FormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        MaterialModule,
        MVMSpinnerBtnModule,
        ReactiveFormsModule,
        ValidationResultsModule,
        TableModule
    ],
    exports: [
        NoteSingleViewComponent,
        NoteEntryComponent,
        NoteComponent,
        NoteConfirmationComponent
    ]
})
export class NoteModule {
}
